var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTiktokMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M40.9724731,12.3084717v-0.0001831c-2.1854858-0.465271-4.1202393-1.6067505-5.5749512-3.194519 c-1.5123901-1.6514893-2.5054321-3.7857056-2.7202759-6.1451416V2h-7.5787964v30.0793457 c-0.0123901,3.5065918-2.8596191,6.3460083-6.3708496,6.3460083c-2.0690308,0-3.9072266-0.9857788-5.0714111-2.5128784h0.0004883 c-0.8449707-1.1073608-1.3016357-2.4619751-1.2995605-3.8548584c0-3.5162354,2.8520508-6.3672485,6.3708496-6.3672485 c0.6557617-0.0001831,1.3076172,0.1002197,1.9325562,0.2984009v-7.6992188 c-0.7303467-0.1000366-1.4674683-0.1425171-2.2042236-0.1269531l-0.0003052,0.0001221 c-7.5563965,0.1560669-13.633606,6.3271484-13.633606,13.916748c0,3.7885742,1.5133057,7.2231445,3.9694214,9.732666 l0.000061,0.000061c0.000061,0.000061,0.000061,0.000061,0.000061,0.000061C11.3209839,44.3967285,14.8477783,46,18.7496338,46 c7.6920166,0,13.9279175-6.2319946,13.9279175-13.9203491V16.711792c2.9593506,2.1141968,6.5845947,3.3582153,10.500061,3.3582153 v-7.5309448C42.4365845,12.5391846,41.6974487,12.4619751,40.9724731,12.3084717z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokMedium);
export default __webpack_public_path__ + "static/media/tiktok--medium.6c7191b5bddfebd8713fb882768b7c53.svg";
export { ForwardRef as ReactComponent };